import { gql } from '@apollo/client'

import { EDIT_DAILY_AMOUNT_FRAGMENT } from '../fragments/editDailyAmountFragment'

const EDIT_DAILY_AMOUNT_QUERY = gql`
  ${EDIT_DAILY_AMOUNT_FRAGMENT}
  query EditDailyAmountQuery(
    $scopeType: AvailablePlansScopeType
    $caloriesMultipleOf: Int!
    $lowerPercentage: Int!
    $upperPercentage: Int!
  ) {
    user {
      id
      ...EditDailyAmountFragment
    }
  }
`

export { EDIT_DAILY_AMOUNT_QUERY }
